module.exports = __webpack_public_path__ + "img/vertical_5_1_7005.aa2e795c.png";